export default __webpack_public_path__ + "svg/CompaniesLogos/Prodigioso_Volcan.svg?53eb395f";